import { AuthProvider } from "./AuthContext";
import {
  ApolloProvider,
  ApolloClient,
  InMemoryCache,
  split,
} from "@apollo/client";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";
//import { createUploadLink } from "apollo-upload-client";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
// import { GET_SITE_SETTINGS } from "./queries";
// import { SiteSettingsProvider } from "./SiteSettingsContext";

import { getMainDefinition } from "@apollo/client/utilities";
import { setContext } from "@apollo/client/link/context";
import Router from "./Router";
import { Toaster } from "sonner";
import { ConfirmationProvider } from "./context/ConfirmationContext";
import { DemoModeProvider } from "./context/DemoModeContext";

const GRAPHQL_ENDPOINT =
  process.env.REACT_APP_API_URL ?? "http://localhost:4000/graphql";
const GRAPHQL_ENDPOINT_WS =
  process.env.REACT_APP_API_URL_WS ?? "ws://localhost:4000/graphql";

const wsLink = new GraphQLWsLink(
  createClient({
    url: GRAPHQL_ENDPOINT_WS,
    connectionParams: {
      //authToken: user.authToken,
      reconnect: true,
    },
  })
);

const httpLinkOrigin = createUploadLink({
  uri: GRAPHQL_ENDPOINT,
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem("furnisystems-token");
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const httpLink = authLink.concat(httpLinkOrigin);

// const httpLink = new HttpLink({
//   uri: GRAPHQL_ENDPOINT,
// });

// The split function takes three parameters:
//
// * A function that's called for each operation to execute
// * The Link to use for an operation if the function returns a "truthy" value
// * The Link to use for an operation if the function returns a "falsy" value

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    // console.log(definition)
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  httpLink
);

export const client = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
  // uri: GRAPHQL_ENDPOINT,
  // link: createUploadLink({
  //   url: GRAPHQL_ENDPOINT,
  // }), // We do need this to handle upload streams.
});

function App() {
  return (
    <div>
      <ApolloProvider client={client as any}>
        <AuthProvider>
          <DemoModeProvider>
            <ConfirmationProvider>
              <Router />
            </ConfirmationProvider>
          </DemoModeProvider>
        </AuthProvider>
      </ApolloProvider>
      <Toaster position="bottom-left" richColors expand />
    </div>
  );
}

export default App;
